
import React, { useEffect, useState } from "react";
// import { Modal, Button } from "react-bootstrap";
import Select from "react-select";
import axios from "../../API/axios";
import usePagedOptions from "../../hooks/usePagedOptions";
// import { toast } from "react-hot-toast";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import {customStyles, wljSelectPortalProps} from "../../selectStyles";
import { quickAddSkill } from "../../utils/industryScopedMaster";
import {
  creatableSkillSelectDefaults,
  onCreatableInputChange,
} from "../../utils/creatableSelectHelpers";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import CreatableSelect from "react-select/creatable";
import { useTranslation } from "react-i18next";
import { Portal } from "../../components/Portal";


const CCVSkillUpdate = ({ resumeId, showSkills, handleUpdateSkillClose, getUserCcv, userUid, skillsData }) => {
    const [display, setDisplay] = useState(false);
    const [value, setValue] = useState([]);
    const [newCreateoption, setNewCreateoption] = useState("");
    const sessionId = localStorage.getItem("sessionId");
    const { t } = useTranslation();
   const language = localStorage.getItem("Lang");

    const [selectedOption, setSelectedOption] = useState(null);
    const [industryList, setIndustryList] = useState([]);
    const [showIndustryInput, setShowIndustryInput] = useState(false);
    const [industryInputValue, setIndustryInputValue] = useState("");

    const fetchPage = async ({ typed, page }) => {
        if (!selectedOption?.value) return { items: [], totalPages: 0 };
        const res = await axios.get(
            `Master/GetSkillsByIndustryDDL?search=${typed || ""}&Fitid=${selectedOption?.value}&pageNumber=${page}&pageSize=100&LangKey=${language}&DeviceType=Web`
        );
        const data = res?.data?.responseData?.data || [];
        const items = data.map((item) => ({ value: item.skllId, label: item.name }));
        const totalPages = res?.data?.responseData?.paging?.totalPages || 1;
        return { items, totalPages };
    };

    const paged = usePagedOptions({ fetchPage, debounceMs: 300 });

    const [toastMessage, setToastMessage] = useState("");
    const [showToast, setShowToast] = useState(false);

    const [warningToastMessage, setWarningToastMessage] = useState("");
    const [showWarningToast, setShowWarningToast] = useState(false);

    const [errorToastMessage, setErrorToastMessage] = useState("");
    const [showErrorToast, setShowErrorToast] = useState(false);

    const getIndustry = () => {
        axios
            .get(`Master/GetFirmIndustryTypeDDL?LangKey=${language}`)
            .then((response) => {
                const res = response.data.responseData;
                const list = Array.isArray(res) ? res : res?.data || [];
                const data = list.map((item) => ({
                    value: item.fitid ?? item.fitId,
                    label: item.name,
                }));
                setIndustryList(data);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    useEffect(() => {
        getIndustry();
    }, []);

    const handleOpen = () => {
        paged.reset();
        paged.onMenuOpen();
    };

    const handleChange = (selected) => {
        setValue(selected || []);
        paged.reset();
    };

    const handleInputChange = (typed, actionMeta) => {
        if (actionMeta && actionMeta.action !== "input-change") {
            return typed;
        }
        paged.onInputChange(typed);
        return typed;
    };

    const handleCreateOption = async (newOption) => {
        const trimmed = String(newOption || "").trim();
        if (!trimmed) return;
        const pending = { label: trimmed, value: trimmed };
        setValue((prev) => [...(Array.isArray(prev) ? prev : []), pending]);
        const created = await quickAddSkill({
            name: trimmed,
            fitid: selectedOption?.value,
            sessionId,
            language,
        });
        setNewCreateoption(created.label);
        setValue((prev) => [...(Array.isArray(prev) ? prev.filter((s) => String(s.value) !== trimmed) : []), created]);
    };

    const handleMenuScrollToBottom = () => {
        paged.onMenuScrollToBottom();
    };

    const resetFormState = () => {
        setDisplay(false);
        setSelectedOption(null);
        setValue([]);
        paged.reset();
        setShowIndustryInput(false);
        setIndustryInputValue("");
    };

    const seedIndustry = (data, industries) => {
        if (!data || Array.isArray(data)) return;

        const fitid = data.fitid ?? data.fitId ?? data.Fitid;
        const name = (
            data.firmIndustryTypeName ||
            data.industryName ||
            data.FirmIndustryTypeName ||
            ""
        ).trim();

        if ((fitid == null || fitid === "") && !name) return;

        const matched =
            (fitid != null && fitid !== ""
                ? industries?.find(
                      (option) =>
                          option.value != null &&
                          String(option.value) === String(fitid)
                  )
                : null) ||
            (name
                ? industries?.find(
                      (option) =>
                          option.label &&
                          option.label.toLowerCase() === name.toLowerCase()
                  )
                : null) ||
            (fitid != null && fitid !== "" || name
                ? {
                      value: fitid != null && fitid !== "" ? fitid : name,
                      label: name || String(fitid),
                  }
                : null);

        if (matched) {
            setSelectedOption(matched);
            setIndustryInputValue(matched.label || "");
            setShowIndustryInput(true);
        }
    };

    useEffect(() => {
        if (!showSkills) {
            resetFormState();
            return;
        }

        if (!skillsData || Array.isArray(skillsData) || !skillsData.skillName) {
            return;
        }

        setValue([
            {
                value:
                    skillsData.skllId ||
                    skillsData.skillId ||
                    skillsData.rsmSkllId ||
                    skillsData.skillName,
                label: skillsData.skillName,
            },
        ]);
        seedIndustry(skillsData, industryList);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showSkills, skillsData, industryList]);

    const UpdateSkill = async () => {
        setDisplay(true);
        const selectedSkills = Array.isArray(value) ? value : value ? [value] : [];
        if (!selectedOption?.value || selectedSkills.length === 0) {
            setWarningToastMessage(t("modals.Please fill all the required fields"));
            setShowWarningToast(true);
            return;
        }

        try {
            const [primary, ...rest] = selectedSkills;
            const postdatadetails = {
                deviceType: "Web",
                sessionId: sessionId,
                rsmId: resumeId,
                rsmSkllId: skillsData.rsmSkllId || skillsData.skillId,
                fitid: selectedOption?.value,
                skillName: primary.label,
                langKey: language === "en" ? "" : language,
            };

            const resData = await axios.post("ResumeData/UpdateRsmSkill", postdatadetails);
            let lastMessage = resData.data.message;

            for (const skill of rest) {
                const addRes = await axios.post("ResumeData/AddRsmSkill", {
                    deviceType: "Web",
                    sessionId: sessionId,
                    fitid: selectedOption.value,
                    skillName: skill.label,
                    rsmId: resumeId,
                    langKey: language === "en" ? "" : language,
                });
                lastMessage = addRes.data.message;
            }

            setToastMessage(lastMessage);
            setShowToast(true);
            handleUpdateSkillClose();
            resetFormState();
            getUserCcv();
        } catch (error) {
            if (error.response && error.response.status === 404) {
                setWarningToastMessage(error.response.data.message);
                setShowWarningToast(true);
            } else {
                setErrorToastMessage(error.response.data.message);
                setShowErrorToast(true);
            }
        }
    };

    const handleIndustryChange = (selectedOption) => {
        setSelectedOption(selectedOption);
        setValue([]);
        paged.reset();
        if (selectedOption) {
            setIndustryInputValue(selectedOption.label);
            setShowIndustryInput(true);
        } else {
            setIndustryInputValue("");
            setShowIndustryInput(false);
        }
    };

    useEffect(() => {
        // when industry filter changes, refetch with current typed
        if (selectedOption?.value) {
            paged.reset();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedOption?.value]);

    return (
        <>
            {showSkills && (
                <Portal layer="modal">
                <div
                    className="modal fade show postAdd wlj-overlay-modal"
                    tabIndex="-1"
                    role="dialog"
                    style={{ display: "flex" }}
                >
                    <div className="modal-dialog  modal-dialog-centered " role="document">
                        <div className="modal-content d-flex justify-content-around p-2">
                            <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                                <h6>{t("User Profile.Update Skill")}</h6>
                                <CloseSharpIcon
                                    className="material-symbols-sharp me-2 pointer"
                                    onClick={() => {
                                        handleUpdateSkillClose();
                                    }}
                                />
                            </div>
              <div className=" pb-4 settings p-2">
                            <div className="mb-4 ">
                                <label htmlFor="about">
                       {t ("User Profile.Industry")}    
                      <span className='text-danger ms-2'>*</span></label>
                                {showIndustryInput ? (
                                    <input
                                        type="text"
                                        className="Dark-Input-from-group form-control"
                                        value={industryInputValue}
                                        onChange={(e) => {
                                            setIndustryInputValue(e.target.value);
                                            setSelectedOption({ ...selectedOption, label: e.target.value });
                                        }}
                                        onBlur={() => {
                                            if (!industryInputValue.trim()) {
                                                setShowIndustryInput(false);
                                            }
                                        }}
                                        autoFocus
                                    />
                                ) : (
                                    <Select
                                        options={industryList}
                                        value={selectedOption}
                                        styles={customStyles} {...wljSelectPortalProps}
                                        onChange={handleIndustryChange}
                                        placeholder={t("User Profile.Select industry")}
                                        className="dropdownBorder"
                                        isClearable
                                    />
                                )}
                                {display && !selectedOption ? (
                                    <span className="error_msg_lbl">{t("User Profile.Please Select industry")} </span>
                                ) : null}
                            </div>
                            <div>
                                 <label htmlFor="about">
                       {t ("User Profile.Skills")}    
                      <span className='text-danger ms-2'>*</span></label>
                                <CreatableSelect
                                    {...creatableSkillSelectDefaults}
                                    value={value}
                                    options={paged.options}
                                    onMenuOpen={handleOpen}
                                    onChange={handleChange}
                                    onMenuScrollToBottom={handleMenuScrollToBottom}
                                    onInputChange={onCreatableInputChange(handleInputChange)}
                                    onCreateOption={handleCreateOption}
                                    className="dropdownBorder"
                                    noOptionsMessage={() => t("User Profile.No options")}
                                    placeholder={t("User Profile.Search and Select Skill")}
                                    invalid={display && (!value || value.length === 0)}
                                    styles={customStyles} {...wljSelectPortalProps}
                                />
                                {display && (!value || value.length === 0) ? (
                                    <span className="error_msg_lbl">{t("User Profile.Please Select Skill")} </span>
                                ) : null}
                            </div>
                            </div>
                            <div className='mt-2 text-end'>
                                <button
                                    type="button"
                                    className="closebtn me-2"
                                    onClick={handleUpdateSkillClose}
                                    style={{ width: "70px" }}
                                >
                                    {t("User Profile.Close")}
                                </button>
                                <button
                                    type="button"
                                    className="mainBtn1"
                                    onClick={UpdateSkill}
                                    style={{ width: "107px" }}
                                >
                                    {t("Manage Job.Update")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                </Portal>
            )}
            <SuccessToast
                show={showToast}
                message={toastMessage}
                onClose={() => setShowToast(false)}
            />
            <WarningToast
                show={showWarningToast}
                message={warningToastMessage}
                onClose={() => setShowWarningToast(false)}
            />
            <ErrorToast
                show={showErrorToast}
                message={errorToastMessage}
                onClose={() => setShowErrorToast(false)}
            />
        </>
    );
};

export default CCVSkillUpdate;
